import { Navigate, Outlet } from 'react-router-dom';
import Layout from '../Layout';
import { useDealer } from '../../context/DealerContext';
import DealerStatePage from './DealerStatePage';
import DealerAgreementGate from '../../pages/dealer/DealerAgreementGate';
import type { DealerAuth } from '../../pages/dealer/types';

/**
 * Spec 085 (§4) — guard of every `/dealer/*` screen, inside `DealerProvider`: a dealer role is checked by
 * `DealerRoutes`; here the membership must be ACTIVE (else `/dealer/blocked`), the switch on (else the
 * "switched off" screen, Flow K) and the click-through agreement accepted (else `DealerAgreementGate`).
 */
export default function RequireDealer({ auth }: { auth: DealerAuth }) {
  const { state, me, blockedCode, reload } = useDealer();

  if (state === 'loading') {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }
  if (state === 'blocked') {
    return <Navigate to="/dealer/blocked" replace state={{ code: blockedCode }} />;
  }

  return (
    <Layout auth={auth} garageName={me?.dealer.tradeName ?? null}>
      {state === 'featureOff' && <DealerStatePage reason="featureOff" />}
      {state === 'error' && <DealerStatePage reason="error" onRetry={reload} />}
      {state === 'ok' && me && (me.agreementAccepted ? <Outlet /> : <DealerAgreementGate />)}
    </Layout>
  );
}
